import { useTranslation } from 'react-i18next'

import avatarPlaceholder from 'assets/avatar-placeholder.svg'
import star from 'assets/star-deep-yellow.svg'
import { Employee } from 'features/authorized/components/portal/components/qr/common/core/entities/employee'
import { useUser } from 'features/authorized/context/user'

type EmployeeCardProps = {
    employee: Employee
}

const EmployeeRow = ({ employee }: EmployeeCardProps) => {
    const { t } = useTranslation()
    const { user: { currency } } = useUser()

    const { avatar, firstName, lastName, stars, tips, role } = employee
    return (
        <div className="flex items-center justify-between py-2.5 gap-4">
            <img
                className="h-20 w-20 rounded-full"
                src={avatar || avatarPlaceholder}
                alt="avatar"
            />
            <div className="flex flex-1 flex-col justify-center gap-3 overflow-x-hidden">
                <div className="flex flex-col gap-0.5">
                    <div className="overflow-hidden overflow-ellipsis font-bold">
                        {firstName} {lastName}
                    </div>
                    <div className="overflow-hidden text-sm text-grey-10">{role}</div>
                </div>

                <div className="flex gap-6">
                    <div className='flex gap-2 shrink-0'>
                        <img className='h-6' src={star} alt='rating' />
                        <span>{stars}</span>
                    </div>
                    <div className="gap-2">
                        <span className='text-grey-70 mr-2'>{t('STATISTICS_EMPLOYEES_TABLE_TIPS')}</span>
                        <span className="font-bold">{tips / 100} {currency}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmployeeRow
